import clsx from "clsx";
import React from "react";
import PlusIcon from "../Icons/PlusIcon";

interface AddButtonProps {
  onClick?: () => void;
  className?: string;
  icon?: React.ReactNode;
  label: string;
  labelClassName?: string;
  disabled?:boolean
}

export default function AddButton({
  onClick,
  className,
  icon = <PlusIcon color="#5A8DF1"/>,
  label,
  labelClassName,
  disabled
}: AddButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`flex flex-row w-fit items-center gap-[4px] mt-[5px] mb-[15px] group disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      disabled={disabled}
    >
      <div className="flex justify-center items-center size-[20px]">{icon}</div>
      <span
        className={clsx(
          "text-sm leading-[21px] font-medium text-primary mt-[2px]",
          labelClassName
        )}
      >
        {label}
      </span>
    </button>
  );
}
